import React from 'react';
import { JobExecutionDetail } from 'components/JobExecution';
import { RefreshOnNavigate } from './RefreshOnNavigate';

export const TenantExecutionDetail: React.FC = () => (
  <RefreshOnNavigate content={<JobExecutionDetail />} />
);
